import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({ providedIn: 'root' })
export class BroadcastService {
  private subject = new Subject<any>();

  sendMessage(message) {
    this.subject.next({ message });
  }

  clearMessage() {
    this.subject.next('');
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }

}
